export async function uploadToSignedUrl(signedUrl, blob) {
  const resp = await fetch(signedUrl, {
    method: "PUT",
    headers: { "Content-Type": "image/jpeg" },
    body: blob,
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`Upload failed: ${resp.status} ${resp.statusText}${text ? " - " + text : ""}`);
  }
  return true;
}
